import {Box, Flex, Text} from '@chakra-ui/react';
import {WidgetBoxWrapper} from './widget-box-wrapper';
import {useGeolocation} from '../../../hooks/geolocation';

export interface MarketplaceHeaderWidgetProps {
  color: string;
  startingPrice: string;
  title: string;
}

export const MarketplaceHeaderWidget: React.FC<MarketplaceHeaderWidgetProps> = (
  props,
) => {
  const {currency, currencyPostfix} = useGeolocation();

  return (
    <WidgetBoxWrapper>
      <Box padding="12px 20px">
        <Flex alignItems="flex-end" justifyContent="space-between" mb={1}>
          <Box>
            <Text as="h3" textStyle="h6">
              {props.title}
            </Text>
          </Box>
          <Flex as="p" textStyle="h7">
            <Text
              as="span"
              fontSize="12px"
              mr={1}
              lineHeight="1"
              mt=".65em"
              display="inline-block"
            >
              Starting from
            </Text>
            <Text
              as="span"
              fontSize="21px"
              whiteSpace="nowrap"
              color={props.color}
            >
              {currency}
              {props.startingPrice}
              <Text as="span" fontSize="0.7em">
                {currencyPostfix}
              </Text>
            </Text>
          </Flex>
        </Flex>
      </Box>
    </WidgetBoxWrapper>
  );
};
